import {
  DEFAULT_LINE_HALF_LENGTH_FEET,
  DEFAULT_LINE_HALF_LENGTH_METERS,
  selectWellCardLineHalfLength,
  useWellCardPanelStore
} from "stores/wellCardPanel";

import { useLengthConversion } from "hooks/useUnitConversion";

/**
 * The half-width the card is working to, in metres: what the user settled on,
 * or the default for the display unit in use.
 *
 * One hook for both readers — the box that shows the number and the derive that
 * asks map-svc for the line — so the section on screen is always the one the
 * box describes.
 *
 * The imperial default is carried back through the same conversion the box
 * shows it with, rather than written here as a metre constant. That is what
 * makes it read as exactly 3,000 ft: whatever factor the unit configuration
 * holds, the number goes out and comes back through it.
 *
 * The display unit is only ever feet once the converter has loaded, so an early
 * render answers in metres rather than mistaking 3,000 ft for 3,000 m. A unit
 * change reloads the page, so nothing here has to react to one.
 */
export function useLineHalfLengthMeters(): number {
  const settled = useWellCardPanelStore(selectWellCardLineHalfLength);
  const { convertBack, getDisplayUnit } = useLengthConversion();

  if (settled != null) return settled;
  return getDisplayUnit() === "ft"
    ? convertBack(DEFAULT_LINE_HALF_LENGTH_FEET)
    : DEFAULT_LINE_HALF_LENGTH_METERS;
}
